import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'

const OemSubscribedVehicleModal = ({ show, onClose, onSubmit, vehicle, oemKey, mode }) => {
  const [formData, setFormData] = useState({
    registrationNumber: '',
    chassisNumber: '',
    model: '',
    note: '',
    vin: ''
  })

  useEffect(() => {
    if (vehicle && mode === 'edit') {
      setFormData({
        registrationNumber: vehicle.registrationNumber || '',
        chassisNumber: vehicle.chassisNumber || '',
        model: vehicle.model || '',
        note: vehicle.note || '',
        vin: vehicle.vin || ''
      })
    } else {
      setFormData({ registrationNumber: '', chassisNumber: '', model: '', note: '', vin: '' })
    }
  }, [vehicle, mode])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = () => {
    if (!formData.chassisNumber.trim()) return
    if (!formData.registrationNumber.trim()) return

    const payload = { oemKey, ...formData }
    if (mode === 'edit' && vehicle?._id) {
      payload._id = vehicle._id
    }
    onSubmit(payload, mode)
  }

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '16px', color: '#1F2A5D' }}>
          {mode === 'edit' ? 'Edit' : 'Add'} Subscribed Vehicle
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='oem-modal-form'>
          <Form.Group>
            <Form.Label>Registration Number <span className='text-danger'>*</span></Form.Label>
            <Form.Control
              type='text'
              name='registrationNumber'
              value={formData.registrationNumber}
              onChange={handleChange}
              placeholder='Enter registration number'
              size='sm'
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Chassis Number <span className='text-danger'>*</span></Form.Label>
            <Form.Control
              type='text'
              name='chassisNumber'
              value={formData.chassisNumber}
              onChange={handleChange}
              placeholder='Enter chassis number'
              size='sm'
            />
          </Form.Group>
          {oemKey === 'nemo' && (
            <Form.Group>
              <Form.Label>VIN</Form.Label>
              <Form.Control
                type='text'
                name='vin'
                value={formData.vin}
                onChange={handleChange}
                placeholder='Enter VIN'
                size='sm'
              />
            </Form.Group>
          )}
          <Form.Group>
            <Form.Label>Model</Form.Label>
            <Form.Control
              type='text'
              name='model'
              value={formData.model}
              onChange={handleChange}
              placeholder='Enter model'
              size='sm'
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Note</Form.Label>
            <Form.Control
              as='textarea'
              rows={2}
              name='note'
              value={formData.note}
              onChange={handleChange}
              placeholder='Optional note'
              size='sm'
            />
          </Form.Group>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' size='sm' onClick={onClose}>Cancel</Button>
        <Button className='oem-modal-submit' size='sm' onClick={handleSubmit}>
          {mode === 'edit' ? 'Update' : 'Add'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default OemSubscribedVehicleModal
